import React from 'react';

import { Button, Modal, Segment } from 'semantic-ui-react';

import API from '../services/api.js';
import { Order, PositionActions, PositionTable, AvailableSymbols } from './index';
import OrdersTable from './OrdersTable';
import _ from 'lodash';

class Position extends React.Component {
	constructor (props) {
		super(props);

		this.state = {
			showedOrder: false,
			showedPTP: false,
			user: props.user,
			symbol: props.symbol,
			position: props.position || undefined,
			ticker: null,
			orders: props.orders || [],
			screen: props.screen || 'trade'
		};
	}

	componentDidMount () {
		const { symbol, ticker, position, screen } = this.state;

		if (symbol && position === undefined) {
			if (screen === 'trade') {
				API.Position.get(this.state.symbol)
					.then(({orders, position}) => {
						this.setState({
							orders,
							position
						});
					})
					.catch(err => {
						console.error(err);
					});
			}

			if (!ticker) {
				this.updateList();
			}
		}
	}

	updateList() {
		const {
			screen
		} = this.state;

		this.setState({
			ticker: setTimeout(() => {
				if (screen === 'trade') {
					API.Position.get(this.state.symbol)
						.then(({orders, position, symbols}) => {
							this.setState({
								position,
								orders
							});
						})
						.catch(err => {
							console.error(err);
						})
						.finally(() => {
							this.updateList();
						})
				}
			}, 2000)
		});
	}

	componentWillUnmount () {
		const { ticker } = this.state;

		clearInterval(ticker);

		this.setState({
			ticker: null
		});
	}

	componentDidUpdate (prevProps) {
		const {
			position,
			orders,
			screen,
			user
		} = this.state;

		if (this && ((this.props.symbol !== prevProps.symbol) || (screen === 'users' && this.props.user !== prevProps.user))) {
			this.setState({
				symbol: this.props.symbol,
				position: this.props.position || undefined,
				orders: this.props.orders || [],
				screen: this.props.screen || 'trade'
			});

			if (screen === 'trade') {
				API.Position.get(this.props.symbol)
					.then(({orders, position}) => {
						this.setState({
							orders,
							position
						});
					})
					.catch(err => {
						console.error(err);
					});
			}
		}
	}

	openModal = (key) => () => {
		this.setState({
			[key]: true
		});
	};

	closeModal = (key) => () => {
		this.setState({
			[key]: false
		});
	};

	render () {
		const {
			showedOrder,
			symbol,
			position,
			orders,
			screen,
		} = this.state;

		return (
			<Segment.Group>
				{((screen === 'trade' && position) || (screen === 'users')) ?
					<>
						{(position ? <><Segment>
							<PositionTable position={position}/>
						</Segment></> : <></>)}
						<Segment>
							<PositionActions screen={screen} symbol={symbol} position={position}/>
						</Segment>
						<Segment>
							<OrdersTable symbol={symbol} orders={orders} position={position}/>
						</Segment>
					</> :
					(screen === 'trade' ? <Segment>
						<Modal
							centered
							open={showedOrder}
							size="small"
							onOpen={this.openModal('showedOrder')}
							trigger={<Button>Новый ордер</Button>}
						>
							<Order symbol={symbol} closeModal={this.closeModal('showedOrder')}/>
						</Modal>
					</Segment> : <></>)
				}
			</Segment.Group>
		);
	}
}

export default Position;
